var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletecross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DD4B40;}\r\n")), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64,0C28.7,0,0,28.7,0,64s28.7,64,64,64s64-28.7,64-64S99.3,0,64,0z M64,122C32,122,6,96,6,64S32,6,64,6 s58,26,58,58S96,122,64,122z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.1,35.8c-1.2-1.2-3.1-1.2-4.2,0L64,59.8l-23.9-24c-1.2-1.2-3.1-1.2-4.3,0s-1.2,3.1,0,4.3l23.9,24L35.9,88 c-1.2,1.2-1.2,3.1,0,4.2c1.2,1.2,3.1,1.2,4.2,0l23.9-24l23.9,24c1.2,1.2,3.1,1.2,4.3,0s1.2-3.1,0-4.3L68.2,64l23.9-24 C93.3,38.8,93.3,37,92.1,35.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletecross);
export default __webpack_public_path__ + "static/media/deletecross.740bc24849b0e29b0ef16dfa893dcaf9.svg";
export { ForwardRef as ReactComponent };